import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

interface DashboardCustomizerDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  visibleMetrics: Record<string, boolean>
  onToggleMetric: (key: string) => void
}

export function DashboardCustomizerDialog({
  open,
  onOpenChange,
  visibleMetrics,
  onToggleMetric,
}: DashboardCustomizerDialogProps) {
  const metrics = [
    { key: 'total_sales', label: 'Vendas Totais' },
    { key: 'active_users', label: 'Utilizadores Ativos' },
    { key: 'new_leads', label: 'Novos Leads' },
    { key: 'growth', label: 'Crescimento' },
  ]

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Personalizar Dashboard</DialogTitle>
          <DialogDescription>
            Escolha as métricas que deseja visualizar no seu painel principal.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {metrics.map((metric) => (
            <div key={metric.key} className="flex items-center space-x-2">
              <Checkbox
                id={metric.key}
                checked={visibleMetrics[metric.key]}
                onCheckedChange={() => onToggleMetric(metric.key)}
              />
              <Label
                htmlFor={metric.key}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                {metric.label}
              </Label>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
